/* --------------------------------------------------------------------------------------
   scan.service.js
   Copyright © 2018 Xerox Corporation. All Rights Reserved. 
   
   Copyright protection claimed includes all forms and matters of copyrightable material 
   and information now allowed by statutory or judicial law or hereinafter granted, 
   including without limitation, material generated from the software programs which 
   are displayed on the screen such as icons, screen display looks, etc.
   -------------------------------------------------------------------------------------
*/

export class scanService {
  /*@ngInject*/
  constructor (appSettings, jobStatusService, dataService) {
    this.appSettings = appSettings
    this.jobStatusService = jobStatusService
    this.dataService = dataService
  }
  scan () {
    return this.dataService.getScanTicket()
      .then(result => this.submitScanTicket(result.Value, this.appSettings.deviceUrl))
      .then(value => {
        return xrxScanV2ParseInitiateScanJob(value.response)
      })
  }
  submitScanTicket (ticket, deviceUrl) {
    return new Promise(function(resolve, reject) {
      submitScanTicket(
        deviceUrl,
        ticket,
        null,
        120,
        (env, response) => resolve({env, response}),
        (env, response, status) => reject({method: 'Submit Scan', env, response, status})
      )
    })
  }
}



// WEBPACK FOOTER //
// ./src/app/gradeTests/services/scan.service.js